module.exports = __webpack_public_path__ + "ace65df5166305736afde878ae5a8537.fbx";